import {faClock} from "@fortawesome/free-solid-svg-icons";

export default faClock;
